import React from "react";
var __jsx = React.createElement;
import { useTranslation } from "@i18n";
import desktopBanner from "../../assets/DesktopMainBanner.png";
import mobileBanner from "../../assets/MobileMainBanner.png";
var scrollToForm = function scrollToForm() {
  var _document$getElementB;
  if (typeof document === "undefined") return;
  (_document$getElementB = document.getElementById("fleet-request-form")) === null || _document$getElementB === void 0 ? void 0 : _document$getElementB.scrollIntoView({
    behavior: "smooth",
    block: "start"
  });
};
var FleetHero = function FleetHero() {
  var _useTranslation = useTranslation(["web_fleet"]),
    tShort = _useTranslation.tShort;
  return /*#__PURE__*/React.createElement("section", null, /*#__PURE__*/React.createElement("div", {
    className: "relative p-4 md:p-0 md:max-h-[733px] overflow-hidden"
  }, /*#__PURE__*/React.createElement("picture", null, /*#__PURE__*/React.createElement("source", {
    media: "(min-width: 768px)",
    srcSet: desktopBanner,
    width: 5760,
    height: 2452
  }), /*#__PURE__*/React.createElement("img", {
    src: mobileBanner,
    alt: tShort("hero_title", {
      ns: "web_fleet"
    }),
    loading: "eager",
    fetchPriority: "high",
    width: 1444,
    height: 1604,
    className: "block w-full h-auto md:h-[733px] object-cover rounded-2xl md:rounded-none"
  })), /*#__PURE__*/React.createElement("div", {
    className: "absolute inset-x-0 top-0 p-4 md:p-0"
  }, /*#__PURE__*/React.createElement("div", {
    className: "md:max-w-[1200px] md:mx-auto px-2 md:gap-5 gap-2 pt-6 md:px-4 md:pt-16 flex flex-col items-center text-center"
  }, /*#__PURE__*/React.createElement("h1", {
    className: "text-2xl md:text-5xl font-extrabold text-primary-new leading-tight mb-4 md:mb-5 max-w-[320px] md:max-w-[1000px]"
  }, tShort("hero_title", {
    ns: "web_fleet"
  })), /*#__PURE__*/React.createElement("p", {
    className: "text-base md:text-2xl text-[#3F4A66] mb-6 md:mb-7 max-w-[300px] md:max-w-[720px]  md:leading-10"
  }, tShort("hero_paragraph", {
    ns: "web_fleet"
  })), /*#__PURE__*/React.createElement("button", {
    type: "button",
    onClick: scrollToForm,
    className: "px-6 md:px-8 py-2.5 md:py-3 bg-primary-new text-white border-none rounded-lg text-sm md:text-lg font-semibold cursor-pointer"
  }, tShort("hero_cta", {
    ns: "web_fleet"
  }))))));
};
export default FleetHero;